import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';


import NavItem from './NavItem';
import { useAuthContext } from 'src/context/AuthContext';




import sack from './sack.svg';
import harvester from './harvester.svg';
import bug from './it-support.png';
import lightingIcon from './lighting-foz.png';

import land from './land.svg';
import { useNavigate } from 'react-router-dom';
const HarvestIcon = ()=>{
  return <img src={harvester} style={{height:24,width:24,marginRight:7}}/>;
};
const EvResultIcon = ()=>{
  return <img src={sack} style={{height:24,width:24,marginRight:7}}/>;
};

const BugIcon = ()=>{
  return <img src={bug} style={{height: 22,width: 22, marginLeft: 3, marginRight: 6}}/>;
};


const landIcon = ()=>{
  return <img src={land} style={{height: 22,width: 22, marginLeft: 3, marginRight: 6}}/>;
};

const LightingIcon = ()=>{
  return <img src={lightingIcon} style={{height:24,width:24,marginRight:7}}/>;

};


// const LandIcon = ()=>{
//   return <img src={land} style={{height:24,width:20,marginRight:6, marginLeft:2}}/>;
// };
const items = [
  {
    href: '/app/harvesting',
    icon: HarvestIcon,
    title: 'Harvesting'
  },
  // {
  //   href: '/app/harvesting',
  //   icon: LandIcon,
  //   title: 'Harvestland'
  // },
  {
    href: '/app/ev-results',
    icon: EvResultIcon,
    title: 'Ev Results'
  },
  {
    href: 'https://docs.google.com/forms/d/e/1FAIpQLSeB0p5f6Luu2Pgr1NEceBLLJO4OTGp1cry70zlve2zI3TOQDA/viewform',
    icon: BugIcon,
    title: 'IT Support',
    isExternal:true
  },
  // {
  //   href: 'https://onedrive.live.com/redir?resid=A54F3136A0B6EEFE%21113&authkey=%21ANJSTpKCo6PrAKw&page=View&wd=target%28Fishing%20and%20Finding.one%7Cee5a92fc-272f-46a9-b12e-16d817add27e%2FFirst%20Messages%7C9d92c22b-2082-4586-888e-985fae29f5d1%2F%29',
  //   icon: LightingIcon,
  //   title: 'Lighting FOZ',
  //   isExternal:true,
  //   groupAccess:[0,1,4]
  // },
  
  // {
  //   href: '/app/basket',
  //   icon: AlertCircleIcon,
  //   title: 'Basket'
  // },
  {
    href: '/app/harvestland',
    icon: landIcon,
    title: 'Harvest Land',
    groupAccess:[]

  },
  // {
  //   href: '/app/account',
  //   icon: UserIcon,
  //   title: 'Account'
  // }
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 48,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const {user, logout} = useAuthContext();
  const navigate = useNavigate();

 

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={!!user && user.photoURL}
          to="/app/harvesting"
        />
        <Typography className={classes.name} color="textPrimary" variant="h5">
          {!!user && user.name|| user.displayName}
        </Typography>
        {/* <Typography
          color="textSecondary"
          variant="body2"
        >
          {user.jobTitle}
        </Typography> */}
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map(item => {
            if(user.role==='admin'||(!item.groupAccess||(item.groupAccess&&item.groupAccess.includes(user.group)))){
              return (
                <NavItem
                  href={item.href}
                  key={item.title}
                  isExternal={item.isExternal}
                  title={item.title}
                  icon={item.icon}
                />
              );
            }
            return null;
            
          })}
          <Hidden lgUp>
            <NavItem
              href={'/login'}
              key={'Logout'}
              title={'Logout'}
              icon={InputIcon}
              onClick={() => {
                logout();
                navigate('/login');
              }}
            />
          </Hidden>
          
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
